import React from 'react'
import StatusApplication from './StatusApplication'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const ExpiredApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editExpiredApplications.role,
    permissionsConfig.editExpiredApplications.action,
    permissionsConfig.editExpiredApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteExpiredApplications.role,
    permissionsConfig.deleteExpiredApplications.action,
    permissionsConfig.deleteExpiredApplications.type
  );

    return (
        <StatusApplication appStatus="6" title="Expired" subTitle="Expired" application_type="0" pageFrom="expired-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
    )
}

export default ExpiredApplications